import React, { useLayoutEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Home from '../pages/Admin/Home/components'
import Dashboard from '../pages/Admin/Dashboard/components'
import HomePage from '../pages/Homepage'
import Campaings from '../pages/Campaings'
import Register from '../pages/Register'
import LoginPage from '../pages/Loginpage'
import MyCard from '../pages/MyCard'
import NotFound from '../pages/NotFound'
import PaymentSpecial from '../pages/MySpecial/Payment'
import ProductDetail from '../pages/ProductDetail/index'
import ProductList from '../pages/ProductList'
import WithClientLayout from './withClientLayout'
import WithAdminLayout from './withAdminLayout'
import ListBanner from '../pages/Admin/HomeAndSiteOperation/BannersCrud/components/ListBanner'
import AddBanner from '../pages/Admin/HomeAndSiteOperation/BannersCrud/components/AddBanner'
import ListVideo from '../pages/Admin/HomeAndSiteOperation/VideoCrud/components/ListVideo'
import AddVideo from '../pages/Admin/HomeAndSiteOperation/VideoCrud/components/AddVideo'
import VideoCategoryList from '../pages/Admin/HomeAndSiteOperation/VideoCrud/components/VideoCategoryList'
import VideoWatchReport from '../pages/Admin/HomeAndSiteOperation/VideoCrud/components/WatchReport'
import AddPoll from '../pages/Admin/SiteReports/PollList/AddPoll/AddPoll'
import MyReturns from '../pages/MySpecial/MyReturns/components'
import MyOffers from '../pages/MySpecial/MyOffers'
import LetterGuarantee from '../pages/MySpecial/CurrentAccount/LetterGuarantee/componnets'
import WebinarCalendar from '../pages/MySpecial/WebinarCalendar'
import DealerSpecificPromotional from '../pages/MySpecial/DealerSpecificPromotional'
import HeaderMySpecial from '../pages/MySpecial/Header/Contact'
import ListConsensus from '../pages/MySpecial/CurrentAccount/Consensus/components/ListConsensus'
import AddConsensus from '../pages/MySpecial/CurrentAccount/Consensus/components/AddConsensus'
import MyCreditCards from '../pages/MySpecial/MyCreditCards/components'
import AccountSummary from '../pages/MySpecial/Reports/AccountSummary'
import Provizyon from '../pages/MySpecial/Reports/Provizyon'
import PODocument from '../pages/MySpecial/Reports/PO/components'
import WarrantyTracking from '../pages/MySpecial/SSH/WarrantyTracking'
import SSHProceduresBrandList from '../pages/MySpecial/SSH/SSHProcedures/components/SSHProceduresBrandList'
import SshProcedures from '../pages/MySpecial/SSH/SSHProcedures/components/SshProcedures'
import FaultTracking from '../pages/MySpecial/SSH/FaultTracking/components'
import SerialNumberCheck from '../pages/MySpecial/SSH/SerialNumberCheck'
import SerialCreditApplication from '../pages/MySpecial/SerialCreditApplication'
import SerialCreditResult from '../pages/MySpecial/SerialCreditApplication/SerialCreditResult'
import CreditPanel from '../pages/MySpecial/SerialCreditApplication/CreditPanel'
import SSHContactForm from '../pages/MySpecial/SSHContactForm'
import AuthorizedServicePoints from '../pages/MySpecial/SSH/AuthorizedServicePoints'
import SSS from '../pages/MySpecial/SSS'
import AddNewUser from '../pages/MySpecial/AddNewUser'
import Password from '../pages/MySpecial/Password'
import InformationUpdate from '../pages/MySpecial/InformationUpdate'
import UserUpdate from '../pages/MySpecial/UserUpdate'
import AddUser from '../pages/Admin/UserOperation/UserCrud/components/AddUser'
import DealerLoginAndOrderReport from '../pages/Admin/OrderOperation/DealerLoginAndOrderReport/index'
import DealerContractApproval from '../pages/Admin/UserOperation/DealerContractApproval/components/DealerContractApproval'
import DealerList from '../pages/Admin/UserOperation/DealerList/components/index'
import FibaInsuranceList from '../pages/Admin/UserOperation/FibaInsuranceList/components/index'
import Fiba from '../pages/MySpecial/Fiba/components/index'
import ListMenu from '../pages/Admin/Settings/MenuCrud/components/ListMenu'
import ListCard from '../pages/Admin/CreditCardOperation/CreaditCardDefinedCrud/components/ListCard'
import AddCard from '../pages/Admin/CreditCardOperation/CreaditCardDefinedCrud/components/AddCard'
import BIN from '../pages/Admin/CreditCardOperation/BIN'
import AddCardBlack from '../pages/Admin/CreditCardOperation/CreditCardBlacklistCrud/components/AddCardBlack'
import ListCardBlack from '../pages/Admin/CreditCardOperation/CreditCardBlacklistCrud/components/ListCardBlack'
import SAP from '../pages/Admin/CreditCardOperation/SAP/components/index'
import NumberIssues from '../pages/Admin/CreditCardOperation/NumberIssues/components/index'
import POSIssues from '../pages/Admin/CreditCardOperation/POSIssues/components/index'
import SuccessfulAIPredict from '../pages/Admin/CreditCardOperation/SuccessfulAIPredict/components/index'
import Successful from '../pages/Admin/CreditCardOperation/Successful/components/index'
import AboutUs from '../pages/About/AboutUs'
import Dpp from '../pages/Dpp/components'
import NetChannel from '../pages/NetChannel/components'
import NetChannelEdu from '../pages/NetChannel/components/education'
import NetChannelApple from '../pages/NetChannelApple/components'
import ListUser from '../pages/Admin/UserOperation/UserCrud/components/ListUser'
import SessionClosed from '../pages/Admin/UserOperation/SessionClosed'
import CurrentLogo from '../pages/Admin/UserOperation/CurrentLogo/Index'
import PrepaidXML from '../pages/Admin/UserOperation/PrepaidXML/components/prepaidXML'
import DefinedCompany from '../pages/Admin/UserOperation/DefinedCompany/Index'
import OrderOperation from '../pages/Admin/OrderOperation/OrderOperation/components/ListOrder'
import OrderListRapor from '../pages/Admin/OrderOperation/OrderRapor/components/ListOrderRapor'
import OrderReturnReport from '../pages/Admin/OrderOperation/OrderReturnReport/components'
import ReturnReports from '../pages/Admin/OrderOperation/ReturnReports/components'
import InformationOrderMail from '../pages/Admin/OrderOperation/İnformationOrderMail/components/İnformationOrderMailList'
import SiteNavigationStatistics from '../pages/Admin/SiteReports/SiteNavigationStatistics'
import SiteNavigationStatistics2 from '../pages/Admin/SiteReports/SiteNavigationStatistics2'
import DealerNavigationStatistics from '../pages/Admin/SiteReports/DealerNavigationStatistics'
import OpportunityMarketReport from '../pages/Admin/OrderOperation/OpportunityMarketReport/components/OpportunityMarketReport'
import BasketQuotaReport from '../pages/Admin/OrderOperation/BasketQuotaReport/components/BasketQuotaReport'
import UsageReport from '../pages/Admin/OrderOperation/UsageReport/components/UsageReport'
import UntouchedOrdersList from '../pages/Admin/OrderOperation/UntouchedOrdersList/components/UntouchedOrdersList'
import HandcraftedOrdersList from '../pages/Admin/OrderOperation/HandcraftedOrdersList/components/HandcraftedOrdersList'
import NoneUntouchedOrdersList from '../pages/Admin/OrderOperation/NoneUntouchedOrdersList/components/NoneUntouchedOrdersList'
import CurrentEnteredOrders from '../pages/Admin/OrderOperation/CurrentEnteredOrders/components/CurrentEnteredOrders'
import SASReport from '../pages/Admin/OrderOperation/SASReport/components/SASReport'
import SAPUpdate from '../pages/Admin/HomeAndSiteOperation/SAP/components/Sap'
import AddProduct from '../pages/Admin/HomeAndSiteOperation/CurrentProductCrud/components/AddProduct'
import AdsAndCampingAdd from '../pages/Admin/HomeAndSiteOperation/AdsAndCampaingCrud/components/AdsAndCampingAdd'
import CampaignQuery from '../pages/Admin/ProductOperation/CampaignQuery/components/CampaignQuery'
import AnnouncementList from '../pages/Admin/HomeAndSiteOperation/AnnouncementList/components/AnnouncementList'
import ExcelAnnouncement from '../pages/Admin/HomeAndSiteOperation/ExcelAnnouncement/components/ExcelAnnouncement'
import BannerClickStatistics from '../pages/Admin/SiteReports/BannerClickStatistics/components'
import IceCatReport from '../pages/Admin/ProductOperation/IceCatReport/components'
import Analytics from '../pages/Admin/SiteReports/Analytics/components'
import ChatbotAnalytics from '../pages/Admin/SiteReports/ChatbotAnalytics/components'
import ChatbotManagementReport from '../pages/Admin/SiteReports/ChatbotManagementReport/components'
import AdminPageAuthGuard from '../pages/Admin/components/AdminPageAuthGuard'
import MailSend from '../pages/Admin/SiteReports/MailSend/components'
import PageAnalysis from '../pages/Admin/SiteReports/PageAnalysis'
import GeneralProductStats from '../pages/Admin/ProductOperation/GeneralProductStats/components'
import PollListChart from '../pages/Admin/SiteReports/PollList/PollListChart'
import PollList from '../pages/Admin/SiteReports/PollList'
import PollProductList from '../pages/Admin/SiteReports/PollProductList'
import ProductClickStatistics from '../pages/Admin/ProductOperation/ProductClickStatistics'
import PromotionalProductLists from '../pages/Admin/ProductOperation/PromotionalProductLists/components'
import ManuelCredit from '../pages/Admin/MailOrderOperation/ManuelCredit/components/ManuelCredit'
import AddAndEdit from '../pages/Admin/CreditCardPaymentCampaigns/AddAndEdit/components/AddAndEdit'
import BankInstallmentReport from '../pages/Admin/CreditCardPaymentCampaigns/Bank/components/BankInstallmentReport'
import WhiteDealerList from '../pages/Admin/UserOperation/WhiteDealer/components/WhiteDealerList'
import TransactionList from '../pages/Admin/CreditCardPaymentCampaigns/Transaction/components/TransactionList'
// Compay Operation
import CompayPaymentReport from '../pages/Admin/CompayOperation/CompayPaymentReport/components/CompayPaymentReport'
import ShoppingCreditReport from '../pages/Admin/CompayOperation/ShoppingCreditReport/components/ShoppingCreditReport'
import ShoppingCreditSettings from '../pages/Admin/CompayOperation/ShoppingCreditReport/components/ShoppingCreditSettings'
// import BrandHelp from "../pages/Admin/BrandPageOperation/BrandHelp/components/BrandHelp";
import BrandInformation from '../pages/Admin/BrandPageOperation/BrandInformation/components/BrandInformation'
import BrandCrud from '../pages/Admin/BrandPageOperation/BrandCrud/components'
import BrandUpdate from '../pages/Admin/BrandPageOperation/BrandInformation/components/BrandUpdate'
import ListBrandNotices from '../pages/Admin/BrandPageOperation/BrandNotices/components/ListBrandNotices'
import AddOrUpdateBrandNotices from '../pages/Admin/BrandPageOperation/BrandNotices/components/AddOrUpdateBrandNotices'
import DealerInformation from '../pages/Admin/DealerInformationFormOperation/DealerInformation/components/DealerInformation'
import BankAdd from '../pages/Admin/BankAndInstallementOperation/BankCrud/components/BankAdd'
import BankList from '../pages/Admin/BankAndInstallementOperation/BankList/components/BankList'
import SubDealerAdd from '../pages/Admin/BankAndInstallementOperation/SubDealerAdd/components/SubDealerAdd'
import SubDealerControl from '../pages/Admin/BankAndInstallementOperation/SubDealerControl/components/SubDealerControl'
import BankUpdateDel from '../pages/Admin/BankAndInstallementOperation/BankCrud/components/BankUpdateDel'
import SurveyMain from '../pages/Survey'
import SSSPazar from '../pages/SSS/components/index'
import AddProductFeatures from '../pages/Admin/ProductOperation/AddProductFeatures/AddProductFeatures'
import AddPropertyModification from '../pages/Admin/ProductOperation/AddingProductAttributeChangeData/AddPropertyModification'
import BestSellerList from '../pages/Admin/ProductOperation/BestSellerList/components/BestSellerList'
import IsProductActive from '../pages/Admin/ProductOperation/IsProductActive/components/index'
import ProductVisibility from '../pages/Admin/ProductOperation/ProductVisibility/components/index'
import CampaignBundleAdd from '../pages/Admin/ProductOperation/CampaignBundleCrud/components/CampaignBundleAdd'
import UndefinedProducts from '../pages/Admin/ProductOperation/FilterPropertiesUndefinedProducts/components/UndefinedProducts'
import OpportunityAisleProductList from '../pages/Admin/ProductOperation/OpportunityAisleProduct/components/OpportunityAisleProductList'
import OpportunityUsageReport from '../pages/Admin/ProductOperation/OpportunityAisleProduct/components/OpportunityUsageReport'
import AddOpportunityAisle from '../pages/Admin/ProductOperation/OpportunityAisleProduct/components/AddOpportunityAisle'
import PriceChecklist from '../pages/Admin/ProductOperation/PriceChecklist/components/PriceChecklist'
import ProductLinkList from '../pages/Admin/ProductOperation/ProductAttributeChangeData/components/ProductLinkList'
import ProductLinkAdd from '../pages/Admin/ProductOperation/ProductAttributeChangeData/components/ProductLinkAdd'
import ProductQuantityLimitList from '../pages/Admin/ProductOperation/ProductQuantityLimit/components/ProductQuantityLimitList'
import ProductSuggestList from '../pages/Admin/ProductOperation/ProductSuggest/components/ProductSuggestList'
import ProductSuggestAdd from '../pages/Admin/ProductOperation/ProductSuggest/components/ProductSuggestAdd'
import AddProductLimitation from '../pages/Admin/ProductOperation/ProductQuantityLimit/components/AddProductLimitation'
import FilterProducts from '../pages/Admin/ProductOperation/ProductsWithNoFilterPropertiesEntered/components/FilterProducts'
import ProductsWithNoPrice from '../pages/Admin/ProductOperation/ProductsWithNoPrice/components/ProductsWithNoPrice'
import ProductsWithNoSpecialPrice from '../pages/Admin/ProductOperation/ProductsWithNoSpecialPrice/components/ProductsWithNoSpecialPrice'
import ProductsWithoutPictures from '../pages/Admin/ProductOperation/ProductsWithoutPictures/components/ProductsWithoutPictures'
import SendMailReports from '../pages/Admin/HomeAndSiteOperation/SendMails/components/index'
import UnspecifiedProductsList from '../pages/Admin/ProductOperation/ProductsWithUnspecifiedProperties/components/UnspecifiedProductsList'
import StopwatchOperationsAdd from '../pages/Admin/ProductOperation/StopwatchOperations/components/StopwatchOperationsAdd'
import SurprisePriceIdentificationAdd from '../pages/Admin/ProductOperation/SurprisePriceIdentification/components/SurprisePriceIdentificationAdd'
import VisualDocumentationList from '../pages/Admin/ProductOperation/VisualDocumentationCrud/components/VisualDocumentationList'
import ProductGroupImageList from '../pages/Admin/ProductOperation/VisualDocumentationCrud/components/ProductGroupImageList'
import VisualDocumentationAdd from '../pages/Admin/ProductOperation/VisualDocumentationCrud/components/VisualDocumentationAdd'
import WithMySpecialLayout from './withMySpecialLayout'
import Extract from '../pages/MySpecial/CurrentAccount/Extract/components/index'
import ExtractList from '../pages/MySpecial/CurrentAccount/Extract/components/listExtract'
import Openbox from '../pages/Openbox'
import MyFavorites from '../pages/MySpecial/MyFavorites'
import Address from '../pages/MySpecial/Address'
import MyspecialMyOrders from '../pages/MySpecial/MyOrders'
import PreOrders from '../pages/MySpecial/PreOrders/components/PreOrderList'
import PreOrderEdit from '../pages/MySpecial/PreOrders/components/EditPreOrder'
import Invoice from '../pages/MySpecial/MyOrders/components/EInvoice'
import ResetPassword from '../pages/ResetPassword'
import AddFrequentlyAskedQuestions from '../pages/Admin/Settings/FrequentlyAskedQuestions/components/AddFrequentlyAskedQuestions'
import ListFrequentlyAskedQuestions from '../pages/Admin/Settings/FrequentlyAskedQuestions/components/ListFrequentlyAskedQuestions'
import BankAccountNumbers from '../pages/FinancialInformation/components/BankAccountNumbers'
import WithFinancialInformationLayout from './withFinancialInformationLayout'
import CreditCardCommissionRates from '../pages/FinancialInformation/components/CreditCardComissionRates'
import FinancialExchange from '../pages/FinancialInformation/components/Exchange'
import FinancialDocuments from '../pages/FinancialInformation/components/FinancialDocuments'
import FrequentlyAskedQuestions from '../pages/FinancialInformation/components/FrequentlyAskedQuestions'
import OpenInvoices from '../pages/MySpecial/Reports/OpenInvoices/components/OpenInvoices'
import EInvoice from '../pages/MySpecial/Reports/EInvoice'
import PeriodicReport from '../pages/MySpecial/Reports/PeriodicReport'
import ImeiSerialNumber from '../pages/MySpecial/Reports/ImeiSerialNumber'
import AppleDep from '../pages/MySpecial/AppleDep/components'
import AppleDepOperation from '../pages/Admin/AppleDepOperation/components'
import VodafonePKDealer from '../pages/MySpecial/Reports/VodafonePKDealer/components/VodafonePKDealer'
import VodafonePKReport from '../pages/MySpecial/Reports/VodafonePKReport/components/VodafonePKReport'
import TemlikHesaplasma from '../pages/MySpecial/Reports/VodafoneTemlikHesaplasma/components/VodafoneTemlikHesaplasma'
import VodafoneOrdersByIMEI from '../pages/MySpecial/Reports/VodafoneOrdersByIMEI/components/VodafoneOrdersByIMEI'
import CreditStatement from '../pages/MySpecial/Reports/CreditStatement'
import CreditCardOperations from '../pages/MySpecial/CreditCardOperations'
import XmlSupport from '../pages/MySpecial/XmlSupport/components/xml'
import Microsoft from '../pages/MySpecial/LicenseTracking/components/microsoft'
import SubscriptionTracking from '../pages/MySpecial/LicenseTracking/components/subscriptionTracking'
import WebinarCalanderAdmin from '../pages/Admin/HomeAndSiteOperation/WebinarCalander/components/WebinarCalanderAdmin'
import BrandDetail from '../pages/BrandDetail/components/BrandDetail'
import AllBrands from '../pages/BrandDetail/components/AllBrands'
import ListAuthorizedServices from '../pages/Admin/BrandPageOperation/AuthorizedServices/components/ListAuthorizedServices'
import AddAuthorizedServices from '../pages/Admin/BrandPageOperation/AuthorizedServices/components/AddAuthorizedServices'
import AddAuthorizedServicesVodafone from '../pages/Admin/BrandPageOperation/AuthorizedServices/components/AddAuthorizedServicesVodafone'
import BasketManagement from '../pages/MyCard/basketManagement'
import AddAuthorizedProcedure from '../pages/Admin/BrandPageOperation/AuthorizedProcedure/components/AddAuthorizedProcedure'
import ListAuthorizedProcedure from '../pages/Admin/BrandPageOperation/AuthorizedProcedure/components/ListAuthorizedProcedure'
import ListXml from '../pages/Admin/UserOperation/XMLUpdate/components/ListXml'
import AddXmlUpdate from '../pages/Admin/UserOperation/XMLUpdate/components/AddXmlUpdate'
import XMLDealer from '../pages/Admin/UserOperation/XMLDealer/components/XmlDealer'
import HomePageProducts from '../pages/Admin/HomeAndSiteOperation/HomePageProducts/components/HomePageProducts'
import Confirmation from '../pages/Register/Confirmation'
import ExchangeRateInformation from '../pages/Admin/Settings/ExchangeRateInformation'
import SiteControl from '../pages/Admin/Settings/SiteControl/components'
import DealerChannel from '../pages/Admin/HomeAndSiteOperation/DealerChannel/components/DealerChannel'
import DealerChannelPrograms from '../pages/MySpecial/DealerChannelPrograms'
import UserRoleDefinitions from '../pages/Admin/Settings/Authorization/UserRoleDefinitions'
import RoleDefinitions from '../pages/Admin/Settings/Authorization/RoleDefinitions'
import AuthorizationDefinitionsToRole from '../pages/Admin/Settings/Authorization/AuthorizationDefinitionsToRole'
import AuthorizationDefinitionsToUser from '../pages/Admin/Settings/Authorization/AuthorizationDefinitionsToUser'
import CampaignBundleList from '../pages/Admin/ProductOperation/CampaignBundleCrud/components/CampaignBundleList'
import FcvCampaignAdd from '../pages/Admin/BankAndInstallementOperation/FCV/components/FcvCampaignAdd'
import ListDealer from '../pages/Admin/HomeAndSiteOperation/DealerChannel/components/ListDealer'
import FcvCampaignList from '../pages/Admin/BankAndInstallementOperation/FCV/components/FcvCampaignList'
import Marketing from '../pages/Dpp/components/marketing'
import Training from '../pages/Dpp/components/training'
import TrainingVideos from '../pages/Dpp/components/videos'
import Mac from '../pages/Dpp/components/mac'
import MicrosoftWorld from '../pages/MicrosoftWorld/components'
import PriceLists from '../pages/PriceLists/components'
import CompabilityTables from '../pages/CompabilityTable/components'
// import { Menu } from "../layouts/components/admin/Menu/Menu";
import HomeDealerChannel from '../pages/Admin/HomeAndSiteOperation/DealerChannel/components/HomeDealerChannel'
import DppAndMicrosoftPages from '../pages/Admin/HomeAndSiteOperation/DppAndMicrosoftPages/components/list'
import DppAndMicrosoftPagesAdd from '../pages/Admin/HomeAndSiteOperation/DppAndMicrosoftPages/components/Add'
import AuthMicrosoftSellers from '../pages/Admin/HomeAndSiteOperation/DppAndMicrosoftPages/components/AuthMicrosoftSellers'
import HomePageProductsList from '../pages/Admin/HomeAndSiteOperation/HomePageProducts/components/HomePageProductsList'
import IyzicoCampaign from '../pages/Admin/ProductOperation/IyzicoCampaign'
import IyzicoCampaignAdd from '../pages/Admin/ProductOperation/IyzicoCampaign/IyzicoCampaignAdd'
import { BaseComponentWithContextProps, componentWithContext } from '../base/customHooks/componentHOC'
import WithSSHLayout from './withSSHLayout'
import ReturnForm from '../pages/MySpecial/MyReturns/components/ReturnForm'
import XmlTokenFree from '../pages/MySpecial/XmlSupport/components/xmlTokenFree'
import XmlStateListing from '../pages/Admin/UserOperation/XmlStateListing/components/XmlStateListing'
import XmlCompanyParametersList from '../pages/Admin/UserOperation/XmlCompanyParameters/components/XmlCompanyParametersList'
import BankAdditionalInstallmentList from '../pages/Admin/BankAndInstallementOperation/AdditionalBankInstallment/components/BankAdditionalInstallmentList'
import AddBankAdditionalInstallment from '../pages/Admin/BankAndInstallementOperation/AdditionalBankInstallment/components/AddBankAdditionalInstallment'
import SellerApplication from '../pages/Admin/DealerInformationFormOperation/DealerInformation/components/SellerApplication'
import DealerCreditCardList from '../pages/Admin/DealerInformationFormOperation/DealerCreditCardList/components'
import AddBankNote from '../pages/Admin/BankAndInstallementOperation/BankNote/components/AddBankNote'
import BankNoteList from '../pages/Admin/BankAndInstallementOperation/BankNote/components/BankNoteList'
import AddBankAccount from '../pages/Admin/BankAndInstallementOperation/BankAccounts/components/AddBankAccount'
import BankAccountList from '../pages/Admin/BankAndInstallementOperation/BankAccounts/components/BankAccountList'
import ProductColorAdd from '../pages/Admin/ProductOperation/ProductColor/components/ProductColorAdd'
import ProductColorList from '../pages/Admin/ProductOperation/ProductColor/components/ProductColorList'
import HomepageNotice from '../pages/Admin/HomeAndSiteOperation/HomePageNotice/components/HomepageNotice'
import DailyOrderDealerList from '../pages/Admin/HomeAndSiteOperation/DailyOrderDealerList/components/DailyOrderDealerList'
import PreOrderList from '../pages/Admin/OrderOperation/PreOrderList/components/PreOrderList'
import CampaignReport from '../pages/Admin/OrderOperation/CampaignReport/components/CampaignReport'
import DealerRiskReport from '../pages/Admin/HomeAndSiteOperation/DealerRiskReport/components/index'
import DealerInformationListVDF from '../pages/Admin/HomeAndSiteOperation/DealerInformationListVDF/components/DealerInformationListVDF'
import EditPreOrder from '../pages/Admin/OrderOperation/PreOrderList/components/EditPreOrder'
import DocumentUpload from '../pages/Admin/ProductOperation/VisualDocumentationCrud/components/DocumentUpload'
import AddBIN from '../pages/Admin/CreditCardOperation/BIN/AddBIN'
import DealerBlockList from '../pages/Admin/CreditCardOperation/DealerPaymentBlock/components/DealerPaymentBlockList'
import XMLAllDealerUpdate from '../pages/Admin/UserOperation/XmlAllDealerUpdate/components/xmlAllDealerUpdate'
import PosCompany from '../pages/Admin/BankAndInstallementOperation/PosCompany/components/PosCompany'
import PosSettings from '../pages/Admin/BankAndInstallementOperation/PosSettings/components/PosSettings'
import CardConsent from '../pages/CardConsent'
import CardPhoneMatching from '../pages/Admin/CreditCardOperation/CardPhoneMatching/components/CardPhoneMatching'
import AddWhiteDealerList from '../pages/Admin/UserOperation/WhiteDealer/components/AddWhiteDealerList'
import NetChannelContentList from '../pages/Admin/HomeAndSiteOperation/NetChannelContent/components/NetChannelContentList'
import NetChannelContentAdd from '../pages/Admin/HomeAndSiteOperation/NetChannelContent/components/NetChannelContentAdd'
import OneConfig from '../pages/OneConfig/components'
import PageAnalysisFromMail from '../pages/Admin/SiteReports/PageAnalysisFromMail'
import VodafoneTemlikDetail from '../pages/MySpecial/Reports/VodafoneTemlikDetail/components/VodafoneTemlikDetail'
import VodafoneTemlikSummary from '../pages/MySpecial/Reports/VodafoneTemlikSummary/components/VodafoneTemlikSummary'
import VodafoneUrunFiyatFarki from '../pages/MySpecial/Reports/VodafoneUrunFiyatFarki/components/VodafoneUrunFiyatFarki'
import ProductSubTypeReport from '../pages/Admin/ProductOperation/ProductSubTypeReport/components/ProductSubTypeReport'
import DealerSubTypeList from '../pages/Admin/UserOperation/DealerSubTypeList/components/index'
import ProductSuggestAISettings from '../pages/Admin/ProductOperation/ProductSuggest/components/ProductSuggestAISettings'
import PKIMEIReport from '../pages/Admin/HomeAndSiteOperation/DealerInformationListVDF/components/PKIMEIReport'
import PKActivationExceptions from '../pages/Admin/HomeAndSiteOperation/DealerInformationListVDF/components/PKActivationExceptions'
import VodafoneGeneralDashboard from '../pages/Admin/HomeAndSiteOperation/DealerInformationListVDF/components/VodafoneGeneralDashboard'
import { IsCreditDealerApi } from '../pages/MyCard/services/isCompayDealerApi'
import PosList from '../pages/Admin/BankAndInstallementOperation/PosCrud/components/PosList'
import Pos from '../pages/Admin/BankAndInstallementOperation/PosCrud/components/Pos'
import PkRates from '../pages/Admin/PesineKontrat/Rates'
import PkSettings from '../pages/Admin/PesineKontrat/Settings'
import ShoppingCreditContractReport from '../pages/Admin/CompayOperation/ShoppingCreditReport/components/ShoppingCreditContractReport'
import KasperskyPage from '../pages/Kaspersky/components'

function AppRoutes(props: BaseComponentWithContextProps) {
  const location = useLocation()

  // Bana Özel yetki kısayolları. IsPermission = en yetkili yönetici, tüm yetkileri kapsar.
  // Sidebar.tsx ile birebir aynı olmalı: menüde görünen sayfanın rotası da tanımlı olmalı.
  /** En yetkili yönetici — kullanıcı yönetimi ekranları; diğer tüm yetkileri de kapsar */
  const isMostAuthorized = props.user.IsPermission || props.user.IsMostAuthorized
  /** Satış ve sipariş hareketlerini izleyebilir (sipariş monitör) */
  const canMonitorOrders = isMostAuthorized || props.user.IsMonitorSalesAndOrder
  /** Finansal ve cari hareketleri izleyebilir (ödeme monitör) */
  const canMonitorFinance = isMostAuthorized || props.user.IsMonitorFinancialAndCurrentMovements
  /** Finansal işlem yapabilir (ödeme yapma) */
  const canMakeFinancialTransactions = isMostAuthorized || props.user.IsMakeFinancialTransactions
  /** Faturalarım, Raporlarım, Seri No / IMEI ve Vodafone raporları: iki izlemeden biri yeterli */
  const canMonitorOrdersOrFinance = canMonitorOrders || canMonitorFinance

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  const getClientRoutes = () => {
    return (
      <>
        <Route path='/' element={<Navigate replace to='/homepage' />} />
        <Route
          path={'/homepage'}
          element={
            <WithClientLayout>
              <HomePage />
            </WithClientLayout>
          }
        />
        <Route
          path={'/campaings'}
          element={
            <WithClientLayout>
              <Campaings />
            </WithClientLayout>
          }
        />
        <Route
          path={'/products'}
          element={
            <WithClientLayout>
              <ProductList />
            </WithClientLayout>
          }
        />
        <Route
          path={'/survey'}
          element={
            <WithClientLayout>
              <SurveyMain />
            </WithClientLayout>
          }
        />
        <Route
          path={'/sss'}
          element={
            <WithClientLayout>
              <SSSPazar />
            </WithClientLayout>
          }
        />
        <Route
          path={'/:type/detail/:id'}
          element={
            <WithClientLayout>
              <ProductDetail />
            </WithClientLayout>
          }
        />
        <Route
          path={'/brands'}
          element={
            <WithClientLayout>
              <AllBrands />
            </WithClientLayout>
          }
        />
        <Route
          path={'/brandDetail'}
          element={
            <WithClientLayout>
              <BrandDetail />
            </WithClientLayout>
          }
        />
        <Route
          path={'/mycard'}
          element={
            <WithClientLayout>
              <MyCard />
            </WithClientLayout>
          }
        />
        <Route
          path={'/mycard/management'}
          element={
            <WithClientLayout>
              <BasketManagement />
            </WithClientLayout>
          }
        />
        <Route
          path={'/openbox'}
          element={
            <WithClientLayout>
              <Openbox />
            </WithClientLayout>
          }
        />
        <Route
          path={'/about'}
          element={
            <WithClientLayout>
              <AboutUs />
            </WithClientLayout>
          }
        />
        <Route
          path={'/microsoft'}
          element={
            <WithClientLayout>
              <MicrosoftWorld />
            </WithClientLayout>
          }
        />
        <Route
          path={'/oneConfig'}
          element={
            <WithClientLayout>
              <OneConfig />
            </WithClientLayout>
          }
        />
        {props.user.IsDPP && (
          <>
            <Route
              path={'/dpp'}
              element={
                <WithClientLayout>
                  <Dpp />
                </WithClientLayout>
              }
            />
            <Route
              path={'/dpp/marketing'}
              element={
                <WithClientLayout>
                  <Marketing />
                </WithClientLayout>
              }
            />
            <Route
              path={'/dpp/training'}
              element={
                <WithClientLayout>
                  <Training />
                </WithClientLayout>
              }
            />
            <Route
              path={'/dpp/training/videos/:categoryId'}
              element={
                <WithClientLayout>
                  <TrainingVideos />
                </WithClientLayout>
              }
            />
            <Route
              path={'/dpp/marketing/mac'}
              element={
                <WithClientLayout>
                  <Mac />
                </WithClientLayout>
              }
            />
          </>
        )}
      </>
    )
  }

  const getCreditRoutes = () => {
    return (
      <>
        <Route
          path='/myspecial/serial-credit-application'
          element={
            <WithMySpecialLayout>
              <SerialCreditApplication />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/serial-credit-result'
          element={
            <WithMySpecialLayout>
              <SerialCreditResult />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/serial-credit-result'
          element={
            <WithMySpecialLayout>
              <SerialCreditResult />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/credit-panel'
          element={
            <WithMySpecialLayout>
              <CreditPanel />
            </WithMySpecialLayout>
          }
        />
      </>
    )
  }

  const getNetChannelAppleRoutes = () => {
    return (
      <>
        <Route path={'/AppleNetChannel'} element={<NetChannelApple />} />
      </>
    )
  }

  const getNetChannelDealerRoutes = () => {
    return (
      <>
        <Route
          path={'/netChannel'}
          element={
            <WithClientLayout>
              <NetChannel />
            </WithClientLayout>
          }
        />
        <Route
          path={'/netChannelEducation'}
          element={
            <WithClientLayout>
              <NetChannelEdu />
            </WithClientLayout>
          }
        />
      </>
    )
  }
  const getMySpecialRoutes = () => {
    return (
      <>
        <Route
          path='/myspecial'
          element={
            <WithMySpecialLayout>
              <HeaderMySpecial />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/InformationUpdate'
          element={
            <WithMySpecialLayout>
              <InformationUpdate />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/myfavorites'
          element={
            <WithMySpecialLayout>
              <MyFavorites />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/MyCreditCards'
          element={
            <WithMySpecialLayout>
              <MyCreditCards />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/CreditCardRates'
          element={
            <WithMySpecialLayout>
              <CreditCardCommissionRates />
            </WithMySpecialLayout>
          }
        />
        {canMonitorFinance && (
          <Route
            path='/myspecial/CreditCardOperations'
            element={
              <WithMySpecialLayout>
                <CreditCardOperations />
              </WithMySpecialLayout>
            }
          />
        )}
        {canMonitorOrdersOrFinance && (
          <Route
            path='/myspecial/reports/provizyon'
            element={
              <WithMySpecialLayout>
                <Provizyon />
              </WithMySpecialLayout>
            }
          />
        )}
        {/* Faturalarım: sipariş izleme veya finansal izleme yetkisi yeterli */}
        {canMonitorOrdersOrFinance && (
          <>
            <Route
              path='/myspecial/reports/podocument'
              element={
                <WithMySpecialLayout>
                  <PODocument />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/reports/open-invoices'
              element={
                <WithMySpecialLayout>
                  <OpenInvoices />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/reports/e-invoice'
              element={
                <WithMySpecialLayout>
                  <EInvoice />
                </WithMySpecialLayout>
              }
            />
          </>
        )}
        {/* Raporlarım + Seri No / IMEI: sipariş izleme veya finansal izleme yetkisi yeterli */}
        {canMonitorOrdersOrFinance && (
          <>
            <Route
              path='/myspecial/reports/periodic-report'
              element={
                <WithMySpecialLayout>
                  <PeriodicReport />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/reports/credit-statement'
              element={
                <WithMySpecialLayout>
                  <CreditStatement />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/reports/imei-serial-number'
              element={
                <WithMySpecialLayout>
                  <ImeiSerialNumber />
                </WithMySpecialLayout>
              }
            />
          </>
        )}
        {/* APPLE DEP — yetkili bayi (AppleDep:AllowedDealerCodes / APPLE DPP alt tipi) + sipariş izleme */}
        {props.user.IsAppleDep && canMonitorOrders && (
          <Route
            path='/myspecial/apple-dep'
            element={
              <WithMySpecialLayout>
                <AppleDep />
              </WithMySpecialLayout>
            }
          />
        )}
        {/* Vodafone raporlarının tamamı: finansal izleme veya sipariş izleme yetkisi yeterli */}
        {props.user.IsVodafone && canMonitorOrdersOrFinance && (
          <>
            <Route
              path='/myspecial/reports/PKDealer'
              element={
                <WithMySpecialLayout>
                  <VodafonePKDealer />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/reports/PKReport'
              element={
                <WithMySpecialLayout>
                  <VodafonePKReport />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/reports/TemlikDetail'
              element={
                <WithMySpecialLayout>
                  <VodafoneTemlikDetail />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/reports/TemlikSummary'
              element={
                <WithMySpecialLayout>
                  <VodafoneTemlikSummary />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/reports/CostAdjustment'
              element={
                <WithMySpecialLayout>
                  <VodafoneUrunFiyatFarki />
                </WithMySpecialLayout>
              }
            />
            {/* Eski adres (Maliyet Düzeltme): yer imleri ve eski bağlantılar yeni adrese düşer. */}
            <Route
              path='/myspecial/reports/UrunFiyatFarki'
              element={<Navigate replace to='/myspecial/reports/CostAdjustment' />}
            />
            <Route
              path='/myspecial/reports/TemlikTakip'
              element={
                <WithMySpecialLayout>
                  <TemlikHesaplasma />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/reports/VodafoneOrdersByIMEI'
              element={
                <WithMySpecialLayout>
                  <VodafoneOrdersByIMEI />
                </WithMySpecialLayout>
              }
            />
          </>
        )}
        {/* Kullanıcı yönetimi yalnızca en yetkili yöneticide */}
        {isMostAuthorized && (
          <Route
            path='/myspecial/UserUpdate'
            element={
              <WithMySpecialLayout>
                <UserUpdate />
              </WithMySpecialLayout>
            }
          />
        )}
        <Route
          path='/myspecial/Password'
          element={
            <WithMySpecialLayout>
              <Password />
            </WithMySpecialLayout>
          }
        />

        {canMonitorFinance && (
          <>
            <Route
              path='/myspecial/currentAccount/extract'
              element={
                <WithMySpecialLayout>
                  <Extract />
                </WithMySpecialLayout>
              }
            />
            <Route path='/myspecial/currentAccount/extract/list' element={<ExtractList />} />
            <Route
              path='/myspecial/currentAccount/letterGuarantee'
              element={
                <WithMySpecialLayout>
                  <LetterGuarantee />
                </WithMySpecialLayout>
              }
            />
          </>
        )}

        {isMostAuthorized && (
          <Route
            path='/myspecial/AddNewUser'
            element={
              <WithMySpecialLayout>
                <AddNewUser />
              </WithMySpecialLayout>
            }
          />
        )}
        <Route
          path='/myspecial/Address'
          element={
            <WithMySpecialLayout>
              <Address />
            </WithMySpecialLayout>
          }
        />
        {canMakeFinancialTransactions && (
          <Route
            path='/myspecial/mypayments'
            element={
              <WithMySpecialLayout>
                <PaymentSpecial />
              </WithMySpecialLayout>
            }
          />
        )}
        {canMonitorOrders && (
          <>
            <Route
              path='/myspecial/myorders'
              element={
                <WithMySpecialLayout>
                  <MyspecialMyOrders />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/preOrders'
              element={
                <WithMySpecialLayout>
                  <PreOrders />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/EditPreOrder'
              element={
                <WithMySpecialLayout>
                  <PreOrderEdit />
                </WithMySpecialLayout>
              }
            />
          </>
        )}
        <Route
          path='/myspecial/returnForm'
          element={
            <WithClientLayout>
              <ReturnForm />
            </WithClientLayout>
          }
        />
        <Route
          path='/myspecial/Fiba'
          element={
            <WithMySpecialLayout>
              <Fiba />
            </WithMySpecialLayout>
          }
        />
        <Route path='/myspecial/EInvoice' element={<Invoice />} />
        <Route path='/xml/xml-request' element={<XmlTokenFree />} />
        {/* Son kullanici kart onay sayfasi: oturum GEREKTIRMEZ, withLogin ile sarmalanmaz. */}
        <Route path='/kart-onay/:token' element={<CardConsent />} />
        {canMonitorOrders && (
          <Route
            path='/myspecial/myReturns'
            element={
              <WithMySpecialLayout>
                <MyReturns />
              </WithMySpecialLayout>
            }
          />
        )}
        <Route
          path='/kaspersky'
          element={
            <WithMySpecialLayout>
              <KasperskyPage />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/ssh/WarrantyTracking'
          element={
            <WithMySpecialLayout>
              <WithSSHLayout></WithSSHLayout>
              <WarrantyTracking />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/ssh/SSHProceduresBrandList'
          element={
            <WithMySpecialLayout>
              <WithSSHLayout></WithSSHLayout>
              <SSHProceduresBrandList />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/ssh/SshProcedures'
          element={
            <WithMySpecialLayout>
              <WithSSHLayout></WithSSHLayout>
              <SshProcedures />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/ssh/FaultTracking'
          element={
            <WithMySpecialLayout>
              <WithSSHLayout></WithSSHLayout>
              <FaultTracking />
            </WithMySpecialLayout>
          }
        />
        {canMonitorOrdersOrFinance && (
          <Route
            path='/myspecial/ssh/SerialNumberCheck'
            element={
              <WithMySpecialLayout>
                <WithSSHLayout></WithSSHLayout>
                <SerialNumberCheck />
              </WithMySpecialLayout>
            }
          />
        )}
        <Route
          path='/myspecial/ssh/SSHContactForm'
          element={
            <WithMySpecialLayout>
              <WithSSHLayout></WithSSHLayout>
              <SSHContactForm />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/ssh/AuthorizedServicePoints'
          element={
            <WithMySpecialLayout>
              <WithSSHLayout></WithSSHLayout>
              <AuthorizedServicePoints />
            </WithMySpecialLayout>
          }
        />
        <Route
          path='/myspecial/ssh/SSS'
          element={
            <WithMySpecialLayout>
              <WithSSHLayout></WithSSHLayout>
              <SSS />
            </WithMySpecialLayout>
          }
        />

        {!props.user.IsVodafone && (
          <>
            <Route
              path={'/priceLists'}
              element={
                <WithClientLayout>
                  <PriceLists />
                </WithClientLayout>
              }
            />
            <Route
              path={'/compabilityTables'}
              element={
                <WithClientLayout>
                  <CompabilityTables />
                </WithClientLayout>
              }
            />
            {canMonitorOrders && (
              <Route
                path='/myspecial/myOffers'
                element={
                  <WithMySpecialLayout>
                    <MyOffers />
                  </WithMySpecialLayout>
                }
              />
            )}
            <Route
              path='/myspecial/xmlSupport'
              element={
                <WithMySpecialLayout>
                  <XmlSupport />
                </WithMySpecialLayout>
              }
            />
            <Route
              path='/myspecial/webinarCalendar'
              element={
                <WithMySpecialLayout>
                  <WebinarCalendar />
                </WithMySpecialLayout>
              }
            />
            {/* Microsoft ESD Takip: sipariş izleme */}
            {canMonitorOrders && (
              <>
                <Route
                  path='/myspecial/licenseTracking/microsoft'
                  element={
                    <WithMySpecialLayout>
                      <Microsoft />
                    </WithMySpecialLayout>
                  }
                />
                <Route
                  path='/myspecial/licenseTracking/subscriptionTracking'
                  element={
                    <WithMySpecialLayout>
                      <SubscriptionTracking />
                    </WithMySpecialLayout>
                  }
                />
              </>
            )}
            {canMonitorOrders && (
              <Route
                path='/myspecial/DealerChannelPrograms'
                element={
                  <WithMySpecialLayout>
                    <DealerChannelPrograms />
                  </WithMySpecialLayout>
                }
              />
            )}
            {canMonitorOrders && (
              <Route
                path='/myspecial/dealerSpecificPromotional'
                element={
                  <WithMySpecialLayout>
                    <DealerSpecificPromotional />
                  </WithMySpecialLayout>
                }
              />
            )}
          </>
        )}
        {/* <Route
          path={"/myspecial/dealerChannelPrograms"}
          element={
            <WithMySpecialLayout>
              <DealerChannelPrograms />
            </WithMySpecialLayout>
          }
        /> */}
      </>
    )
  }
  const getFinansalInformationRoutes = () => {
    return (
      <>
        <Route
          path='/financial-information/bank-account-numbers'
          element={
            <WithFinancialInformationLayout>
              <BankAccountNumbers />
            </WithFinancialInformationLayout>
          }
        />

        <Route
          path='/financial-information/credit-card-commission-rates'
          element={
            <WithFinancialInformationLayout>
              <CreditCardCommissionRates />
            </WithFinancialInformationLayout>
          }
        />
        <Route
          path='/financial-information/exchange'
          element={
            <WithFinancialInformationLayout>
              <FinancialExchange />
            </WithFinancialInformationLayout>
          }
        />
        <Route
          path='/financial-information/financial-documents'
          element={
            <WithFinancialInformationLayout>
              <FinancialDocuments />
            </WithFinancialInformationLayout>
          }
        />
        <Route
          path='/financial-information/frequently-asked-questions'
          element={
            <WithFinancialInformationLayout>
              <FrequentlyAskedQuestions />
            </WithFinancialInformationLayout>
          }
        />
      </>
    )
  }
  const getAdminRoutes = () => {
    return (
      <>
        <Route
          path='/admin/home'
          element={
            <WithAdminLayout>
              <Home />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/dashboard'
          element={
            <WithAdminLayout>
              <Dashboard />
            </WithAdminLayout>
          }
        />
        {/* APPLE DEP yönetimi: bayi/Reseller ID tanımları, tüm gönderimler, RE/OV/VD, ham JSON */}
        <Route
          path='/admin/AppleDepOperation'
          element={
            <WithAdminLayout>
              <AppleDepOperation />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/banner/list'
          element={
            <WithAdminLayout>
              <ListBanner />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/ListUser'
          element={
            <WithAdminLayout>
              <ListUser />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/banner/add'
          element={
            <WithAdminLayout>
              <AddBanner />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/video/list'
          element={
            <WithAdminLayout>
              <ListVideo />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/video/add'
          element={
            <WithAdminLayout>
              <AddVideo />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/video-category/list'
          element={
            <WithAdminLayout>
              <VideoCategoryList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/video/watch-report'
          element={
            <WithAdminLayout>
              <VideoWatchReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/AddUser'
          element={
            <WithAdminLayout>
              <AddUser />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/DealerLoginAndOrderReport'
          element={
            <WithAdminLayout>
              <DealerLoginAndOrderReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/DealerList'
          element={
            <WithAdminLayout>
              <DealerList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/DealerContractApproval'
          element={
            <WithAdminLayout>
              <DealerContractApproval />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/UserOperation/FibaInsuranceList'
          element={
            <WithAdminLayout>
              <FibaInsuranceList />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/UserOperation/SessionClosed'
          element={
            <WithAdminLayout>
              <SessionClosed />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/CreditCardOperation/BIN'
          element={
            <WithAdminLayout>
              <BIN />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/CreditCardOperation/AddBIN'
          element={
            <WithAdminLayout>
              <AddBIN />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/CreditCardOperation/DealerPaymentBlockList'
          element={
            <WithAdminLayout>
              <DealerBlockList />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/CreditCardOperation/CardPhoneMatching'
          element={
            <WithAdminLayout>
              <CardPhoneMatching />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/CreditCardOperation/SAP'
          element={
            <WithAdminLayout>
              <SAP />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/CreditCardOperation/POSIssues'
          element={
            <WithAdminLayout>
              <POSIssues />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/CreditCardOperation/Successful'
          element={
            <WithAdminLayout>
              <Successful />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/CreditCardOperation/SuccessfulAIPredict'
          element={
            <WithAdminLayout>
              <SuccessfulAIPredict />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/DefinedCompany'
          element={
            <WithAdminLayout>
              <DefinedCompany />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/XMLUpdate/ListXML'
          element={
            <WithAdminLayout>
              <ListXml />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/XMLUpdate/addXMLUpdate'
          element={
            <WithAdminLayout>
              <AddXmlUpdate />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/XMLDealer'
          element={
            <WithAdminLayout>
              <XMLDealer />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/XMLAllDealerUpdate'
          element={
            <WithAdminLayout>
              <XMLAllDealerUpdate />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/XMLCompanyParametersList'
          element={
            <WithAdminLayout>
              <XmlCompanyParametersList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/xmlStateListing'
          element={
            <WithAdminLayout>
              <XmlStateListing />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/CurrentLogo'
          element={
            <WithAdminLayout>
              <CurrentLogo />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/PrepaidXML'
          element={
            <WithAdminLayout>
              <PrepaidXML />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/ListOrder'
          element={
            <WithAdminLayout>
              <OrderOperation />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/ListOrderRapor'
          element={
            <WithAdminLayout>
              <OrderListRapor />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/OrderReturnReport'
          element={
            <WithAdminLayout>
              <OrderReturnReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/ReturnReports'
          element={
            <WithAdminLayout>
              <ReturnReports />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/InformationOrderMail'
          element={
            <WithAdminLayout>
              <InformationOrderMail />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/SiteNavigationStatistics'
          element={
            <WithAdminLayout>
              <SiteNavigationStatistics />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/SiteNavigationStatistics2'
          element={
            <WithAdminLayout>
              <SiteNavigationStatistics2 />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/DealerNavigationStatistics'
          element={
            <WithAdminLayout>
              <DealerNavigationStatistics />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/OpportunityMarketReport'
          element={
            <WithAdminLayout>
              <OpportunityMarketReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/BasketQuotaReport'
          element={
            <WithAdminLayout>
              <BasketQuotaReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/UsageReport'
          element={
            <WithAdminLayout>
              <UsageReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/HandcraftedOrdersList'
          element={
            <WithAdminLayout>
              <HandcraftedOrdersList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/UntouchedOrdersList'
          element={
            <WithAdminLayout>
              <UntouchedOrdersList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/NoneUntouchedOrdersList'
          element={
            <WithAdminLayout>
              <NoneUntouchedOrdersList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/CampaignReport'
          element={
            <WithAdminLayout>
              <CampaignReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/DealerRiskReport'
          element={
            <WithAdminLayout>
              <DealerRiskReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/CurrentEnteredOrders'
          element={
            <WithAdminLayout>
              <CurrentEnteredOrders />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/SASReport'
          element={
            <WithAdminLayout>
              <SASReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/MailSend'
          element={
            <WithAdminLayout>
              <MailSend />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/AddPoll'
          element={
            <WithAdminLayout>
              <AddPoll />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductClickStatistics'
          element={
            <WithAdminLayout>
              <ProductClickStatistics />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/BannerClickStatistics'
          element={
            <WithAdminLayout>
              <BannerClickStatistics />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/PollList'
          element={
            <WithAdminLayout>
              <PollList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/PollListChart'
          element={
            <WithAdminLayout>
              <PollListChart />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/IceCatReport'
          element={
            <WithAdminLayout>
              <IceCatReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/PromotionalProductLists'
          element={
            <WithAdminLayout>
              <PromotionalProductLists />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/PollProductList'
          element={
            <WithAdminLayout>
              <PollProductList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/PageAnalysis'
          element={
            <WithAdminLayout>
              <PageAnalysis />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/pageAnalysisFromMail'
          element={
            <WithAdminLayout>
              <PageAnalysisFromMail />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/GeneralProductStats'
          element={
            <WithAdminLayout>
              <GeneralProductStats />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/Analytics'
          element={
            <WithAdminLayout>
              <Analytics />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/ChatbotAnalytics'
          element={
            <WithAdminLayout>
              <ChatbotAnalytics />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/SiteReports/ChatbotManagementReport'
          element={
            <WithAdminLayout>
              {/* Kullanıcı bazlı sayfa kontrolü (ChatbotManagementReportIDList); uçlar backend'de ayrıca korunur. */}
              <AdminPageAuthGuard route='ChatbotManagementReportAuth' title='Chatbot Yönetim Raporu'>
                <ChatbotManagementReport />
              </AdminPageAuthGuard>
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/SAPUpdate'
          element={
            <WithAdminLayout>
              <SAPUpdate />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/DealerChannel'
          element={
            <WithAdminLayout>
              <DealerChannel />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/ListDealer'
          element={
            <WithAdminLayout>
              <ListDealer />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/HomeDealerChannel'
          element={
            <WithAdminLayout>
              <HomeDealerChannel />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/DPPAndMicrosoftPagesList'
          element={
            <WithAdminLayout>
              <DppAndMicrosoftPages />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/DPPAndMicrosoftPagesAdd'
          element={
            <WithAdminLayout>
              <DppAndMicrosoftPagesAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/AuthMicrosoftSellers'
          element={
            <WithAdminLayout>
              <AuthMicrosoftSellers />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/NetChannelContentList'
          element={
            <WithAdminLayout>
              <NetChannelContentList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/NetChannelContentAdd'
          element={
            <WithAdminLayout>
              <NetChannelContentAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/HomepageNotice'
          element={
            <WithAdminLayout>
              <HomepageNotice />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/DailyOrderDealerList'
          element={
            <WithAdminLayout>
              <DailyOrderDealerList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/OrderOperation/PreOrderList'
          element={
            <WithAdminLayout>
              <PreOrderList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/SendReportMails'
          element={
            <WithAdminLayout>
              <SendMailReports />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/DealerInformationListVDF'
          element={
            <WithAdminLayout>
              <DealerInformationListVDF />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/HomeAndSiteOperation/PKIMEIReport'
          element={
            <WithAdminLayout>
              <PKIMEIReport />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/HomeAndSiteOperation/PKActivationExceptions'
          element={
            <WithAdminLayout>
              <PKActivationExceptions />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/HomeAndSiteOperation/VodafoneGeneralDashboard'
          element={
            <WithAdminLayout>
              <VodafoneGeneralDashboard />
            </WithAdminLayout>
          }
        />

        <Route
          path='/admin/OrderOperation/EditPreOrder'
          element={
            <WithAdminLayout>
              <EditPreOrder />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/CurrentProductCrud/AddProduct'
          element={
            <WithAdminLayout>
              <AddProduct />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/AdsAndCampingCrud/AdsAndCampingAdd'
          element={
            <WithAdminLayout>
              <AdsAndCampingAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/CampaignQuery'
          element={
            <WithAdminLayout>
              <CampaignQuery />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/WebinarCalander'
          element={
            <WithAdminLayout>
              <WebinarCalanderAdmin />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/HomePageProducts'
          element={
            <WithAdminLayout>
              <HomePageProducts />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/HomePageProductsList'
          element={
            <WithAdminLayout>
              <HomePageProductsList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/AnnouncementList'
          element={
            <WithAdminLayout>
              <AnnouncementList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/HomeAndSiteOperation/ExcelAnnouncement'
          element={
            <WithAdminLayout>
              <ExcelAnnouncement />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/MailOrderOperation/ManuelCredit'
          element={
            <WithAdminLayout>
              <ManuelCredit />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/CreditCardPaymentCampaigns/BankInstallmentReport'
          element={
            <WithAdminLayout>
              <BankInstallmentReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/WhiteDealerList'
          element={
            <WithAdminLayout>
              <WhiteDealerList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/AddWhiteDealerList'
          element={
            <WithAdminLayout>
              <AddWhiteDealerList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/CreditCardPaymentCampaigns/TransactionList'
          element={
            <WithAdminLayout>
              <TransactionList />
            </WithAdminLayout>
          }
        />
        {/* Compay Operation Routes */}
        {/* <Route
          path='/admin/CompayOperation/PaymentReport'
          element={
            <WithAdminLayout>
              <CompayPaymentReport />
            </WithAdminLayout>
          }
        /> */}
        <Route
          path='/admin/CompayOperation/CreditReport'
          element={
            <WithAdminLayout>
              <ShoppingCreditReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/CompayOperation/CreditContractReport'
          element={
            <WithAdminLayout>
              <ShoppingCreditContractReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/CompayOperation/CreditSettings'
          element={
            <WithAdminLayout>
              <ShoppingCreditSettings />
            </WithAdminLayout>
          }
        />
        {/* <Route
          path="/admin/BrandPageOperation/BrandHelp"
          element={
            <WithAdminLayout>
              <BrandHelp />
            </WithAdminLayout>
          }
        /> */}
        <Route
          path='/admin/BrandPageOperation/BrandInformation'
          element={
            <WithAdminLayout>
              <BrandInformation />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/BrandCrud'
          element={
            <WithAdminLayout>
              <BrandCrud />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/BrandUpdate'
          element={
            <WithAdminLayout>
              <BrandUpdate />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/BrandNotices/ListBrandNotices'
          element={
            <WithAdminLayout>
              <ListBrandNotices />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/BrandNotices/AddOrUpdateBrandNotices'
          element={
            <WithAdminLayout>
              <AddOrUpdateBrandNotices />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/authorizedServices/listAuthorizedServices'
          element={
            <WithAdminLayout>
              <ListAuthorizedServices />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/authorizedProcedure/addAuthorizedProcedure'
          element={
            <WithAdminLayout>
              <AddAuthorizedProcedure />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/authorizedProcedure/listAuthorizedProcedure'
          element={
            <WithAdminLayout>
              <ListAuthorizedProcedure />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/authorizedServices/addAuthorizedServices'
          element={
            <WithAdminLayout>
              <AddAuthorizedServices />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/DealerInformationFormOperation/DealerInformation'
          element={
            <WithAdminLayout>
              <DealerInformation />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/DealerInformationFormOperation/SellerApplication'
          element={
            <WithAdminLayout>
              <SellerApplication />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/DealerInformationFormOperation/DealerCreditCardList'
          element={
            <WithAdminLayout>
              <DealerCreditCardList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/BankCrud'
          element={
            <WithAdminLayout>
              <BankUpdateDel />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/BankList'
          element={
            <WithAdminLayout>
              <BankList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/BankCrud/add'
          element={
            <WithAdminLayout>
              <BankAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/AdditionalBankInstallment/AdditionalBankInstallmentList'
          element={
            <WithAdminLayout>
              <BankAdditionalInstallmentList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/AdditionalBankInstallment/AddBankAdditionalInstallment'
          element={
            <WithAdminLayout>
              <AddBankAdditionalInstallment />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/BankNote/AddBankNote'
          element={
            <WithAdminLayout>
              <AddBankNote />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/BankNote/BankNoteList'
          element={
            <WithAdminLayout>
              <BankNoteList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/BankAccounts/AddBankAccount'
          element={
            <WithAdminLayout>
              <AddBankAccount />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/BankAccounts/BankAccountList'
          element={
            <WithAdminLayout>
              <BankAccountList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/Pos/PosList'
          element={
            <WithAdminLayout>
              <PosList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/PesineKontrat/Rates'
          element={
            <WithAdminLayout>
              <PkRates />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/PesineKontrat/Settings'
          element={
            <WithAdminLayout>
              <PkSettings />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/Pos/Pos'
          element={
            <WithAdminLayout>
              <Pos />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/PosCompany'
          element={
            <WithAdminLayout>
              <PosCompany />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/PosSettings'
          element={
            <WithAdminLayout>
              <PosSettings />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/SubDealerAdd'
          element={
            <WithAdminLayout>
              <SubDealerAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/SubDealerControl'
          element={
            <WithAdminLayout>
              <SubDealerControl />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/AddPropertyModification'
          element={
            <WithAdminLayout>
              <AddPropertyModification />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/BestSellerList'
          element={
            <WithAdminLayout>
              <BestSellerList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/IsProductActive'
          element={
            <WithAdminLayout>
              <IsProductActive />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductVisibility'
          element={
            <WithAdminLayout>
              <ProductVisibility />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductSubTypeReport'
          element={
            <WithAdminLayout>
              <ProductSubTypeReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/UserOperation/DealerSubTypeList'
          element={
            <WithAdminLayout>
              <DealerSubTypeList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/CampaignBundleList'
          element={
            <WithAdminLayout>
              <CampaignBundleList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/CampaignBundleAdd'
          element={
            <WithAdminLayout>
              <CampaignBundleAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/fcv/fcvCampaignAdd'
          element={
            <WithAdminLayout>
              <FcvCampaignAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BankAndInstallementOperation/fcv/fcvCampaignList'
          element={
            <WithAdminLayout>
              <FcvCampaignList />
            </WithAdminLayout>
          }
        />

        {/* MARKA SAYFALARI ROUTE*/}

        <Route
          path='/admin/BrandPageOperation/BrandInformation'
          element={
            <WithAdminLayout>
              <BrandInformation />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/BrandCrud'
          element={
            <WithAdminLayout>
              <BrandCrud />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/BrandUpdate'
          element={
            <WithAdminLayout>
              <BrandUpdate />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/BrandNotices/ListBrandNotices'
          element={
            <WithAdminLayout>
              <ListBrandNotices />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/BrandNotices/AddOrUpdateBrandNotices'
          element={
            <WithAdminLayout>
              <AddOrUpdateBrandNotices />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/AuthorizedServices/ListAuthorizedServices'
          element={
            <WithAdminLayout>
              <ListAuthorizedServices />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/AuthorizedProcedure/AddAuthorizedProcedure'
          element={
            <WithAdminLayout>
              <AddAuthorizedProcedure />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/AuthorizedProcedure/ListAuthorizedProcedure'
          element={
            <WithAdminLayout>
              <ListAuthorizedProcedure />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/AuthorizedServices/AddAuthorizedServices'
          element={
            <WithAdminLayout>
              <AddAuthorizedServices />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/BrandPageOperation/AuthorizedServices/AddAuthorizedServicesVodafone'
          element={
            <WithAdminLayout>
              <AddAuthorizedServicesVodafone />
            </WithAdminLayout>
          }
        />

        {/* ÜRÜN RAPORLARI ROUTE*/}

        <Route
          path='/admin/ProductOperation/IyzicoCampaign'
          element={
            <WithAdminLayout>
              <IyzicoCampaign />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/IyzicoCampaign/add'
          element={
            <WithAdminLayout>
              <IyzicoCampaignAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/UndefinedProducts'
          element={
            <WithAdminLayout>
              <UndefinedProducts />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/AddProductFeatures'
          element={
            <WithAdminLayout>
              <AddProductFeatures />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/OpportunityAisleProductList'
          element={
            <WithAdminLayout>
              <OpportunityAisleProductList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/OpportunitMarketUsageReport'
          element={
            <WithAdminLayout>
              <OpportunityUsageReport />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/AddOpportunityAisle'
          element={
            <WithAdminLayout>
              <AddOpportunityAisle />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/PriceChecklist'
          element={
            <WithAdminLayout>
              <PriceChecklist />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductLinkList'
          element={
            <WithAdminLayout>
              <ProductLinkList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductLinkAdd'
          element={
            <WithAdminLayout>
              <ProductLinkAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductQuantityLimitList'
          element={
            <WithAdminLayout>
              <ProductQuantityLimitList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductSuggestList'
          element={
            <WithAdminLayout>
              <ProductSuggestList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductSuggestAdd'
          element={
            <WithAdminLayout>
              <ProductSuggestAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductSuggestAISettings'
          element={
            <WithAdminLayout>
              <ProductSuggestAISettings />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductColorAdd'
          element={
            <WithAdminLayout>
              <ProductColorAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductColorList'
          element={
            <WithAdminLayout>
              <ProductColorList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/AddProductLimitation'
          element={
            <WithAdminLayout>
              <AddProductLimitation />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/FilterProducts'
          element={
            <WithAdminLayout>
              <FilterProducts />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductsWithNoPrice'
          element={
            <WithAdminLayout>
              <ProductsWithNoPrice />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductsWithNoSpecialPrice'
          element={
            <WithAdminLayout>
              <ProductsWithNoSpecialPrice />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductsWithoutPictures'
          element={
            <WithAdminLayout>
              <ProductsWithoutPictures />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/UnspecifiedProductsList'
          element={
            <WithAdminLayout>
              <UnspecifiedProductsList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/StopwatchOperationsAdd'
          element={
            <WithAdminLayout>
              <StopwatchOperationsAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/SurprisePriceIdentificationAdd'
          element={
            <WithAdminLayout>
              <SurprisePriceIdentificationAdd />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/VisualDocumentationList'
          element={
            <WithAdminLayout>
              <VisualDocumentationList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/ProductGroupImageList'
          element={
            <WithAdminLayout>
              <ProductGroupImageList />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/DocumentUpload'
          element={
            <WithAdminLayout>
              <DocumentUpload />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/ProductOperation/VisualDocumentationAdd'
          element={
            <WithAdminLayout>
              <VisualDocumentationAdd />
            </WithAdminLayout>
          }
        />

        {/* GENEL AYARLAR ROUTE*/}

        <Route
          path='/admin/Settings/FrequentlyAskedQuestions/add'
          element={
            <WithAdminLayout>
              <AddFrequentlyAskedQuestions />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/Settings/FrequentlyAskedQuestions'
          element={
            <WithAdminLayout>
              <ListFrequentlyAskedQuestions />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/Settings/ExchangeRateInformation'
          element={
            <WithAdminLayout>
              <ExchangeRateInformation />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/Settings/ListMenu'
          element={
            <WithAdminLayout>
              <ListMenu />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/Settings/SiteControl'
          element={
            <WithAdminLayout>
              <SiteControl />
            </WithAdminLayout>
          }
        />

        {/* YETKİLENDİRME ROUTE*/}

        <Route
          path='/admin/Authorization/AddOrUpdateRole'
          element={
            <WithAdminLayout>
              <RoleDefinitions />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/Authorization/AddUserToRole'
          element={
            <WithAdminLayout>
              <UserRoleDefinitions />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/Authorization/AddAuthorizationToRole'
          element={
            <WithAdminLayout>
              <AuthorizationDefinitionsToRole />
            </WithAdminLayout>
          }
        />
        <Route
          path='/admin/Authorization/AddAuthorizationToUser'
          element={
            <WithAdminLayout>
              <AuthorizationDefinitionsToUser />
            </WithAdminLayout>
          }
        />
      </>
    )
  }

  return (
    <div>
      <Routes>
        <Route path={'/login'} element={<LoginPage />} />
        <Route path={'/register'} element={<Register />} />
        <Route path={'/resetPassword/:number'} element={<ResetPassword />} />
        <Route path='/confirmation' element={<Confirmation />} />
        {!props.user.IsApple && getClientRoutes()}
        {!props.user.IsApple && props.user.IsAdmin && !props.user.IsRemote && getAdminRoutes()}
        {!props.user.IsApple && getMySpecialRoutes()}
        {!props.user.IsApple && getFinansalInformationRoutes()}
        {props.user.IsApple && getNetChannelAppleRoutes()}
        {!props.user.IsApple && props.user.IsNetChannelDealer && getNetChannelDealerRoutes()}
        {!props.user.IsApple && props.user.IsCredit && ((props.user.IsMonitorSalesAndOrder && props.user.IsOrder) || props.user.IsMostAuthorized) && getCreditRoutes()}
        <Route path={'*'} element={<NotFound />} />
      </Routes>
    </div>
  )
}

export default componentWithContext(AppRoutes)
